import { Monitor, Smartphone } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApercuCampagne, type CampagneNewsletter } from '../../api/newsletter.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
import styles from './NewsletterPage.module.css';
type Appareil = 'ordinateur' | 'mobile';
/** Aperçu isolé de l'e-mail tel que le serveur le compose, en largeur ordinateur ou mobile. */
export function ApercuCampagne({
  campagne,
  sujet,
  expediteur,
}: {
  campagne: CampagneNewsletter;
  sujet: string;
  expediteur: string | null;
}) {
  const { t } = useTranslation('regie');
  const { galerieSlug } = useShellContext();
  const apercu = useApercuCampagne(galerieSlug, campagne.id);
  const [appareil, setAppareil] = useState<Appareil>('ordinateur');
  return (
    <section className={styles.section} aria-label={t('newsletter.etapes.apercu')}>
      <h2>{t('newsletter.apercu.titre')}</h2>
      <p className={styles.aide}>{t('newsletter.apercu.aide')}</p>
      <div className={styles.filtres} role="group" aria-label={t('newsletter.apercu.appareil')}>
        {(
          [
            ['ordinateur', Monitor],
            ['mobile', Smartphone],
          ] as const
        ).map(([a, Icone]) => (
          <button
            type="button"
            key={a}
            className={styles.filtre}
            aria-pressed={appareil === a}
            onClick={() => setAppareil(a)}
          >
            <Icone size={16} aria-hidden="true" /> {t(`newsletter.apercu.${a}`)}
          </button>
        ))}
      </div>
      <div className={styles.fenetreMail} data-appareil={appareil}>
        <dl className={styles.enteteMail}>
          <div>
            <dt>{t('newsletter.apercu.de')}</dt>
            <dd>{expediteur ?? t('newsletter.apercu.expediteurInconnu')}</dd>
          </div>
          <div>
            <dt>{t('newsletter.apercu.objet')}</dt>
            <dd>{sujet}</dd>
          </div>
        </dl>
        <ErreurNewsletter erreur={apercu.error} />
        {apercu.isPending ? <p role="status">{t('newsletter.apercu.chargement')}</p> : null}
        {apercu.data ? (
          <iframe
            className={styles.cadre}
            title={t('newsletter.campagne.apercuTitre')}
            sandbox=""
            srcDoc={apercu.data.html}
          />
        ) : null}
      </div>
      <p className={styles.aide}>{t('newsletter.apercu.pasDeTest')}</p>
    </section>
  );
}
